import { debounceTime } from 'rxjs';

export const irdDebounceTime = <T>() => debounceTime<T>(400);
